export enum BeneficiaryMakingClaimTo {
    ALL_PROCEEDS = 'All proceeds on the deceased claim',
    DUE_TO_ME = 'Only the portion due to me as one of the beneficiaries of the member'
}